import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNoDataErrorWidget = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    aria-label="NoDataErrorWidget"
    {...props}
  >
    <circle cx={8} cy={8} r={8} fill="url(#NoDataErrorWidget_svg__a)" />
    <path
      fill="#fff"
      d="M9 11.4a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1.8-3a.8.8 0 1 0 1.6 0V4a.8.8 0 1 0-1.6 0z"
    />
    <defs>
      <linearGradient
        id="NoDataErrorWidget_svg__a"
        x1={13}
        x2={-7}
        y1={11.75}
        y2={11.333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#949EB2" />
        <stop offset={1} stopColor="#F2F5F7" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgNoDataErrorWidget;
